// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4044":"2f227398","4086":"dd541c6c","5318":"dd541c6c","6519":"5e524878"}[chunkId] + ".chunk.css";
};